import React from 'react';
export function Footer() {
  return <footer className="bg-brand-darker py-12 px-4 border-t border-brand-primary/10 text-center" data-id="element-104">
      <div className="max-w-4xl mx-auto" data-id="element-105">
        <div className="mb-8" data-id="element-106">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-brand-primary/10 text-brand-accent text-sm font-bold tracking-wide border border-brand-primary/20 mb-4" data-id="element-107">
            🌿 MAMÁ SIN CAOS®
          </span>
          <p className="text-brand-cream-light font-serif text-xl mb-2" data-id="element-108">
            El sistema de lactancia N°1 para mamás primerizas en Argentina.
          </p>
          <p className="text-brand-primary italic" data-id="element-109">
            Porque criar no tiene que doler.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-6 text-brand-primary/80 mb-12 text-sm" data-id="element-110">
          <a href="mailto:soporte.mamasinkos@gmail.com" className="hover:text-brand-accent transition-colors" data-id="element-111">
            📧 soporte.mamasinkos@gmail.com
          </a>
          <a href="#" className="hover:text-brand-accent transition-colors" data-id="element-112">
            📲 @mamasincaos
          </a>
          <a href="#" className="hover:text-brand-accent transition-colors" data-id="element-113">
            🌐 www.mamasincaos.store
          </a>
        </div>

        <div className="text-brand-primary/40 text-xs space-y-4" data-id="element-114">
          <p data-id="element-115">
            © SR Digitales — Mamá sin Caos® 2026 — Todos los derechos
            reservados.
          </p>
          <p className="font-serif text-brand-primary/60 text-base italic" data-id="element-116">
            🌿 "La próxima toma puede ser diferente."
          </p>
        </div>
      </div>
    </footer>;
}